import { ThirdPartyType } from "@pepper/signature-react/dist/cjs/interfaces/signature";
import { CustomSignature } from "../../AppStyledComponents";
import CustomHeader from "../../components/CustomHeader/CustomHeader";
import ErrorImg from "../../img/errorImg.png";
import { ErrorBody, ErrorSubtitle, ErrorTitle } from "./ErrorStyledComponents";

const ErrorComponent = () => {
  return (
    <CustomSignature>
      <CustomHeader firmaStyle={"ECO"} typeSignature={ThirdPartyType.PEPPER} />
      <ErrorBody>
        <img width={"70%"} src={ErrorImg} alt="Error" />
        <ErrorTitle>¡Ups!</ErrorTitle>
        <ErrorSubtitle>
          Ha habido un problema y no se ha podido completar el proceso.
        </ErrorSubtitle>
      </ErrorBody>
    </CustomSignature>
  );
};

export default ErrorComponent;
